import React, { FunctionComponent } from 'react'
import { FlexStyle } from 'react-native'
import styled from 'styled-components/native'

import { ReactionTypeEnum, SubcategoryIdEnum } from 'api/gen'
import { ReactionChoiceValidation } from 'features/reactions/components/ReactionChoiceValidation/ReactionChoiceValidation'
import { useSubcategory } from 'libs/subcategories'
import { Separator } from 'ui/components/Separator'
import { HorizontalTile } from 'ui/components/tiles/HorizontalTile'
import { OfferName } from 'ui/components/tiles/OfferName'
import { ValidationMark } from 'ui/components/ValidationMark'
import { ViewGap } from 'ui/components/ViewGap/ViewGap'
import { Typo } from 'ui/theme'

type Props = {
  subcategoryId: SubcategoryIdEnum
  offerName: string
  dateUsed: string
  handleOnPressReactionButton: (reactionType: ReactionTypeEnum) => void
  reactionStatus?: ReactionTypeEnum | null
  imageUrl?: string
}

export const ReactionChoiceModalBodyWithValidation: FunctionComponent<Props> = ({
  subcategoryId,
  offerName,
  dateUsed,
  reactionStatus,
  handleOnPressReactionButton,
  imageUrl,
}) => {
  const { categoryId } = useSubcategory(subcategoryId)

  return (
    <Container gap={6}>
      <Typo.Title3>Partage-nous ton avis&nbsp;!</Typo.Title3>
      <ViewGap gap={4}>
        <Separator.Horizontal />
        <HorizontalTileContainer gap={4}>
          <HorizontalTile categoryId={categoryId} imageUrl={imageUrl}>
            <Column flex={1}>
              <Row>
                <OfferNameContainer>
                  <OfferName title={offerName} />
                </OfferNameContainer>
              </Row>
              <SubtitleContainer gap={1}>
                <ValidationMark isValid />
                <UsedText>Utilisé</UsedText>
                <DateUsedText>{dateUsed}</DateUsedText>
              </SubtitleContainer>
            </Column>
          </HorizontalTile>
        </HorizontalTileContainer>
        <Separator.Horizontal />
      </ViewGap>
      <StyledReactionChoiceValidation
        reactionStatus={reactionStatus}
        handleOnPressReactionButton={handleOnPressReactionButton}
        likeLabel="J’aime"
        dislikeLabel="Je n’aime pas"
      />
    </Container>
  )
}

const Container = styled(ViewGap)(({ theme }) => ({
  marginTop: theme.designSystem.size.spacing.xl,
}))

const HorizontalTileContainer = styled(ViewGap)({
  flexDirection: 'row',
  alignItems: 'center',
})

const SubtitleContainer = styled(ViewGap)({
  flexDirection: 'row',
  alignItems: 'center',
})

const UsedText = styled(Typo.BodyAccentXs)(({ theme }) => ({
  color: theme.designSystem.color.text.success,
}))

const DateUsedText = styled(Typo.BodyAccentXs)(({ theme }) => ({
  color: theme.designSystem.color.text.subtle,
}))

const StyledReactionChoiceValidation = styled(ReactionChoiceValidation)(({ theme }) => ({
  marginBottom: theme.designSystem.size.spacing.xxxxl,
}))

const Flex = styled.View<FlexStyle>(({ flex, justifyContent, alignItems, gap, flexDirection }) => ({
  flexDirection,
  flex,
  alignItems,
  justifyContent,
  gap,
}))

const Column = Flex

const Row = styled(Flex).attrs({
  flexDirection: 'row',
  alignItems: 'center',
})``

const OfferNameContainer = styled.View({
  flexShrink: 1,
})
